import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "trezo-card bg-primary-500 mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[5px] md:mb-[25px] sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "mb-0 text-white" }
const _hoisted_5 = {
  key: 0,
  class: "trezo-card-subtitle mt-[10px] sm:mt-0"
}
const _hoisted_6 = { class: "mb-0 text-white" }
const _hoisted_7 = { class: "trezo-card-content" }
const _hoisted_8 = { class: "relative z-[1] sm:flex items-center justify-between" }
const _hoisted_9 = { class: "inline-block md:block ltr:mr-[25px] rtl:ml-[25px] md:ltr:mr-0 md:rtl:ml-0 mt-[15px] md:mt-0" }
const _hoisted_10 = { class: "block text-white font-semibold mt-[13px]" }
const _hoisted_11 = {
  key: 0,
  class: "block text-white text-xs mt-[5px] opacity-80"
}
const _hoisted_12 = { class: "inline-block md:block ltr:mr-[25px] rtl:ml-[25px] md:ltr:mr-0 md:rtl:ml-0 mt-[15px] md:mt-0" }
const _hoisted_13 = { class: "block text-white font-semibold mt-[13px]" }
const _hoisted_14 = {
  key: 0,
  class: "block text-white text-xs mt-[5px] opacity-80"
}
const _hoisted_15 = { class: "inline-block md:block ltr:mr-[25px] rtl:ml-[25px] md:ltr:mr-0 md:rtl:ml-0 mt-[15px] md:mt-0" }
const _hoisted_16 = { class: "block text-white font-semibold mt-[13px]" }
const _hoisted_17 = {
  key: 0,
  class: "block text-white text-xs mt-[5px] opacity-80"
}
const _hoisted_18 = { class: "inline-block md:block ltr:mr-[25px] rtl:ml-[25px] md:ltr:mr-0 md:rtl:ml-0 mt-[15px] md:mt-0" }
const _hoisted_19 = { class: "block text-white font-semibold mt-[13px]" }
const _hoisted_20 = {
  key: 0,
  class: "block text-white text-xs mt-[5px] opacity-80"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.directT('ecommerce.orderDetails.trackingID')) + ": " + _toDisplayString(_ctx.order?.orderid || 'N/A'), 1)
      ]),
      (_ctx.order?.status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.directT('ecommerce.orderDetails.status')) + ": " + _toDisplayString(_ctx.formatStatus(_ctx.order.status)), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "block absolute left-0 right-0 top-[25px] -z-[1] border-t border-dashed border-white hidden md:inline-block" }, null, -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass(["rounded-full bg-primary-500 text-center text-white font-semibold w-[50px] h-[50px] leading-[48px] border border-dashed border-white", { 'bg-info-400': _ctx.isCurrentOrCompleted('order_placed') }])
          }, " 01 ", 2),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.directT('ecommerce.orderDetails.orderPlaced')), 1),
          (_ctx.stepDate('order_placed'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.stepDate('order_placed')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass(["rounded-full bg-primary-500 text-center text-white font-semibold w-[50px] h-[50px] leading-[48px] border border-dashed border-white", { 'bg-info-400': _ctx.isCurrentOrCompleted('packed') }])
          }, " 02 ", 2),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.directT('ecommerce.orderDetails.packed')), 1),
          (_ctx.stepDate('packed'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.stepDate('packed')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: _normalizeClass(["rounded-full bg-primary-500 text-center text-white font-semibold w-[50px] h-[50px] leading-[48px] border border-dashed border-white", { 'bg-info-400': _ctx.isCurrentOrCompleted('shipped') }])
          }, " 03 ", 2),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.directT('ecommerce.orderDetails.shipped')), 1),
          (_ctx.stepDate('shipped'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.stepDate('shipped')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", {
            class: _normalizeClass(["rounded-full bg-primary-500 text-center text-white font-semibold w-[50px] h-[50px] leading-[48px] border border-dashed border-white ltr:ml-auto rtl:mr-auto", { 'bg-info-400': _ctx.isCurrentOrCompleted('delivered') }])
          }, " 04 ", 2),
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.directT('ecommerce.orderDetails.delivered')), 1),
          (_ctx.stepDate('delivered'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.stepDate('delivered')), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}